import { render, staticRenderFns } from "./create-assessment.vue?vue&type=template&id=4a142195"
import script from "./create-assessment.vue?vue&type=script&lang=js"
export * from "./create-assessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports